import {useIntl} from '@sail/intl';
import {useSelector} from 'src/v2/state/store';

export const useAmountDisplay = (): string | null => {
  const intl = useIntl();

  const currency = useSelector((state) => state.paymentDetails.currency);
  const originalAmount = useSelector(
    (state) => state.paymentDetails.originalAmount,
  );
  const originalCurrency = useSelector(
    (state) => state.paymentDetails.originalCurrency,
  );
  const paymentAmount = useSelector((state) => state.paymentDetails.amount);

  // Off-session/setup sessions have no payment_details, so paymentDetails
  // is left at its default ({amount: 0, currency: ''}) and there's no
  // amount to display.
  if (!currency) {
    return null;
  }

  const hasOriginalAmount =
    originalAmount !== null && originalCurrency !== null;

  if (hasOriginalAmount) {
    return intl.formatCurrency(originalAmount, {
      currency: originalCurrency,
      style: 'symbol',
    });
  }

  return intl.formatCurrency(paymentAmount, {currency, style: 'symbol'});
};
